import { render } from "./upcoming.vue?vue&type=template&id=b7b97340&scoped=true"
import script from "./upcoming.vue?vue&type=script&lang=js"
export * from "./upcoming.vue?vue&type=script&lang=js"

import "./upcoming.vue?vue&type=style&index=0&id=b7b97340&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b97340"]])

export default __exports__